import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'

import 'normalize.css/normalize.css'

// import 'fullpage.js/vendors/scrolloverflow' // Optional. When using scrollOverflow:true
// import './fullpage.scrollHorizontally.min' // Optional. When using fullpage extensions
import VueFullPage from 'vue-fullpage.js'
import { Button, Row, Col } from 'element-ui'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import { Swiper as SwiperClass, Pagination, Mousewheel, Autoplay, Navigation } from 'swiper/swiper.esm'
import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter'
import 'swiper/swiper-bundle.css'
SwiperClass.use([Pagination, Mousewheel, Autoplay, Navigation])
Vue.use(getAwesomeSwiper(SwiperClass))
// const { Swiper, SwiperSlide } = getAwesomeSwiper(SwiperClass)

Vue.use(Button)
Vue.use(Row)
Vue.use(Col)

Vue.use(VueFullPage)

Vue.use(VueAwesomeSwiper)

Vue.config.productionTip = false

// if (window.device.type !== 'desktop') {
// eslint-disable-next-line no-inner-declarations
function init () {
  // 获取屏幕宽度
  const html = document.documentElement
  let width = html.clientWidth
  // console.log('宽', width)
  let height = html.clientHeight
  // console.log('高', height)
  // 设计稿的宽度
  if (window.device.type !== 'desktop') {
    const designWidth = 750
    const designHeight = 1334
    const tempW = (height * designWidth) / designHeight
    const tempH = (width * designHeight) / designWidth
    // 手机稿的宽度
    // designWidth = 640
    if (tempW < width) {
      width = tempW
    } else {
      height = tempH
    }
    html.style.fontSize = (width / designWidth) * 100 + 'px'
  } else {
    const designWidth = 1920
    const designHeight = 1080
    const tempW = (height * designWidth) / designHeight
    const tempH = (width * designHeight) / designWidth
    // console.log(tempW, tempH, 'WH')
    if (tempW < width) {
      width = tempW
    } else {
      height = tempH
    }
    // 设置根元素字体大小。此时为宽的10等分
    html.style.fontSize = (width / designWidth) * 100 + 'px'
  }
}
init()
// 监听手机旋转的事件的时机，重新设置
window.addEventListener('orientationchange', init)
// 监听手机窗口变化，重新设置
window.addEventListener('resize', init)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
